var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 0C3.808 0 0 3.808 0 8.5C0 13.192 3.808 17 8.5 17C13.192 17 17 13.192 17 8.5C17 3.808 13.192 0 8.5 0ZM12.1045 4.89444C11.11 3.89994 9.80948 3.39844 8.50048 3.39844L8.50048 8.49844L4.89648 12.1024C6.88548 14.0914 10.1155 14.0914 12.113 12.1024C14.102 10.1134 14.102 6.88344 12.1045 4.89444ZM1.69922 8.49922C1.69922 12.2562 4.74222 15.2992 8.49922 15.2992C12.2562 15.2992 15.2992 12.2562 15.2992 8.49922C15.2992 4.74222 12.2562 1.69922 8.49922 1.69922C4.74222 1.69922 1.69922 4.74222 1.69922 8.49922Z",
    fill: "#8993A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.153d91ec95bf0be4588a55dea19286eb.svg";
export { ForwardRef as ReactComponent };